/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'

const basePath = '/customers'

const CustomerEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
  ({
    fetchCustomers: builder.query<any, any>({
      query: (params) => ({
        url: `${basePath}`,
        params,
      }),
      providesTags: ['customers']
    }),

    fetchCustomerById: builder.query<any, string>({
      query: (id) => `${basePath}/${id}`,
      providesTags: ['customers']
    }),

    createCustomer: builder.mutation<any, any>({
      query: (body) => ({
        url: `${basePath}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['customers']
    }),

    updateCustomer: builder.mutation<any, { id: string; body: any }>({
      query: ({ id, body }) => ({
        url: `${basePath}/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['customers']
    }),

    deleteCustomer: builder.mutation<any, string>({
      query: (id) => ({
        url: `${basePath}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['customers']
    }),
  })

export default CustomerEndpoints
